// Classes.
import { BaseComponentLocator } from "./base.component-locator";

// Interfaces.
import { ComponentLocatorInterface } from "../interfaces/component-locator.interface";

export enum RankSortingTypeEnum {
  Points = "POINTS",
  Name = "NAME",
  Team = "TEAM",
  Ranking = "RANKING",
  Record = "RECORD"
}

/**
 * Sort athletes in indoor pages.
 *
 * @export
 * @class RankSortingLocatorComponent
 * @extends {BaseComponentLocator}
 */
export class RankSortingLocatorComponent extends BaseComponentLocator {
  protected validSortings: RankSortingTypeEnum[] = [];
  protected _sortingType: RankSortingTypeEnum = undefined;
  protected _orderAsc = false;


  /**
   * Creates an instance of RankSortingLocatorComponent.
   *
   * @param {RankSortingTypeEnum} [_value=undefined]
   *   List of rank types (points, team...).
   *
   * @memberof RankSortingLocatorComponent
   */
  public constructor(protected _value: RankSortingTypeEnum = undefined) {
    super();
  }

  /**
   * Converts to string.
   *
   * @returns {string}
   * @memberof RankSortingLocatorComponent
   */
  public toString(): string {
    return this._sortingType + "-" + (this._orderAsc ? "asc" : "desc");
  }

  /**
   * Set type of sorting.
   */
  set sortingType(sortingType: RankSortingTypeEnum) {
    this._sortingType = sortingType;
  }

  /**
   * Gets the type of sorting to apply.
   *
   * @type {RankSortingTypeEnum}
   * @memberof RankSortingLocatorComponent
   */
  get sortingType(): RankSortingTypeEnum {
    return this._sortingType;
  }

  /**
   * Set sort type (ascendent / descendent).
   *
   * @memberof RankSortingLocatorComponent
   */
  set asc(isAsc: boolean) {
    this._orderAsc = isAsc;
  }

  /**
   * Get type of sort (ascendent / descendent).
   *
   * @type {boolean}
   * @memberof RankSortingLocatorComponent
   */
  get asc(): boolean {
    return this._orderAsc;
  }

  /**
   * Get the sorting value to send to api (+points, -team...).
   *
   * @readonly
   * @memberof RankSortingLocatorComponent
   */
  get sortingSend() {
    return this._sortingType ? this._orderAsc === false ? '-' + String(this._sortingType) : '' + String(this.sortingType) : null;
  }

}

